import apiService from '@/services/apiService'

const BASE = '/api/devoluciones'
const unwrap = (response) => response?.data?.data

export default {
  crear(payload) {
    return apiService.post(BASE, payload).then(unwrap)
  },
  listarPorVenta(idVenta) {
    return apiService.get(BASE, { id_venta: idVenta }).then(unwrap)
  },
  // Historial general de la tabla `devoluciones`, sin id_venta. Ya no lo usa
  // ninguna pantalla: `NotasCreditoView` lista desde `/api/notas-credito`, que
  // trae las NC de los dos orígenes (SPEC_NOTAS_DE_CREDITO RN-139).
  listar({ pagina = 1, pageSize = 10 } = {}) {
    return apiService.get(BASE, { pagina, pageSize }).then(unwrap)
  }
}
